<template>
    <md-button
        title="Delete order"
        class="md-danger md-just-icon md-round"
        :class="[canDelete ? '' : 'button-disabled']"
        @click.stop="handleDelete()"
    >
        <md-icon>
            delete
            <md-tooltip v-if="!canDelete" md-direction="left">
                Orders with {{ status }} status cannot be deleted.
            </md-tooltip>
        </md-icon>
    </md-button>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests } from '@/helpers';

export default {
    name: 'DeleteOrderButton',
    props: {
        orderId: {
            type: [Number, String],
            default: () => null
        },
        status: {
            type: String,
            default: () => null
        },
        canDelete: {
            type: Boolean,
            default: true
        }
    },
    mixins: [GeneralMixin],
    methods: {
        handleDelete() {
            if (!this.canDelete) 
                return;

            this.$messageBox
                .show({
                    class: 'sm-modal-container',
                    title: 'Delete Order',
                    body:
                        'Deleting this order will also delete associated stop and items. Are you sure you want to proceed?',
                    buttons: ['Confirm', 'Cancel']
                })
                .then(async (response) => {
                    if (response.toLowerCase() === 'confirm') 
                        await this.handleConfirmDelete();
                });
        },
        async handleConfirmDelete() {
            this.$_handleLoaderState(true, 'DELETING...');
            const payload = {
                method: 'delete'
            };
            const api = `/api/orders/${this.orderId}`;
            try {
                await handleRequests(api, payload);

                this.$notify({
                    message: 'Order was deleted successfully.',
                    type: 'success'
                });

                this.$emit('orderDeleted', true);
                this.$_handleLoaderState(false);
            } catch (e) {
                if ((e.status === 400 || e.status === 401) && e.data?.length > 0) {
                    let messageObj = {
                        type: 'danger',
                        message: e.data[0]
                    };

                    if (e.data?.length > 1) {
                        const message = e.data.map((error) => `• ${error}`).join('\n');
                        messageObj = {
                            ...messageObj,
                            dangerouslyUseHTMLString: true,
                            message: `<div style="white-space: pre-line">${message}</div>`
                        };
                    }

                    this.$notify(messageObj);
                } else {
                    this.$notify({
                        type: 'danger',
                        message: 'Unable to delete order.'
                    });
                }

                this.$emit('orderDeleted', false);
                this.$_handleLoaderState(false);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.button-disabled {
    opacity: 0.2 !important;
    cursor: not-allowed;
    pointer-events: all !important;
}
</style>
